module.exports = __webpack_public_path__ + "img/Logo-Tourisme-Handicap.d04f408d.png";